const styles = ({ screenSizes }) => ({
  marginBottom: 0,
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {},
});

export default styles;
